export const WRONG_OLD_PASSWORD = "WRONG_OLD_PASSWORD";
export const PASSWORD_TOO_SHORT = "PASSWORD_TOO_SHORT";
// Another candidate of the step (signer, fallback or chief) already approved or rejected it.
export const ERROR_STEP_ALREADY_HANDLED = "ERROR_STEP_ALREADY_HANDLED";
export const ERROR_USER_CANNOT_APPROVE = "ERROR_USER_CANNOT_APPROVE";
// The person already signs another step of the flow.
export const ERROR_FLOW_STEP_USER_TAKEN = "ERROR_FLOW_STEP_USER_TAKEN";
// Approving the step that registers the paper needs its registration number.
export const ERROR_REGISTRATION_NUMBER_MISSING = "ERROR_REGISTRATION_NUMBER_MISSING";
// An info step needs every line filled (one value per line, at most 128 characters).
export const ERROR_INFO_LINES_MISSING = "ERROR_INFO_LINES_MISSING";
// 409: the info step's lines changed after the paper was opened.
export const ERROR_INFO_LINES_CHANGED = "ERROR_INFO_LINES_CHANGED";
